import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import useDeviceScreen from '../../../hooks/useDeviceScreen';
import CommonHeaderRight from './CommonHeaderRight';
import useDarkMode from '../../../hooks/useDarkMode';
import logo from '../../../assets/logos/logo.png';
import logodark from '../../../assets/logos/logodark.png';

const DefaultHeader = () => {
	const { themeStatus } = useDarkMode();
	useDeviceScreen();
	return (
		<Header>
			<HeaderLeft className='header-logo-left'>
				<img
					src={themeStatus === 'dark' ? logodark : logo}
					id='cmpLogo'
					className='cmplogo'
					alt='Company'
					height={40}
				/>
			</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default DefaultHeader;
